module.exports = __webpack_public_path__ + "static/media/file13.d6bcaa82.jpg";